/**
 * CR-8681: Admin Setup > Branding > Main Company Details — Contact Email,
 * Phone Number and Address.
 *
 * They are read back from the platform settings (`GET /core/settings/platform/`,
 * which overlays a company admin's own Admin Setup overrides), so they are saved
 * through the same endpoint rather than with the branding colours: for a
 * company admin that stores them on their own company, for Helix on the
 * platform row. The server validates the email.
 */
import type { PlatformSettingsUpdate } from '../../../lib/api';
import type { ThemeSettings } from './types';

/** The three contact fields, keyed as the API stores them. */
export type CompanyContactDetailsPayload = Required<
  Pick<PlatformSettingsUpdate, 'contact_email' | 'company_phone' | 'company_address'>
>;

/**
 * Build the contact-details save from the Branding screen's values.
 *
 * Every field is sent, blank included, so clearing a field clears it.
 *
 * @param theme - the Branding screen's current values
 * @returns the trimmed contact fields for `platformSettingsAPI.patchSettings`
 * @link useAdminSettings for the save that sends it
 */
export function companyContactDetailsPayload(theme: ThemeSettings): CompanyContactDetailsPayload {
  return {
    contact_email: theme.contactEmail.trim(),
    company_phone: theme.companyPhone.trim(),
    company_address: theme.companyAddress.trim(),
  };
}
